import { render } from "./SavingMoneyCardGetRecord.vue?vue&type=template&id=2cd8878c&scoped=true"
import script from "./SavingMoneyCardGetRecord.vue?vue&type=script&lang=js"
export * from "./SavingMoneyCardGetRecord.vue?vue&type=script&lang=js"

import "../../../styles/van-sticky-nav.css?vue&type=style&index=0&id=2cd8878c&scoped=scoped&lang=css"
import "./SavingMoneyCardGetRecord.vue?vue&type=style&index=1&id=2cd8878c&scoped=scoped&lang=css"

import exportComponent from "/Users/leaf/Desktop/gmhwork/h5/zksq_H5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cd8878c"]])

export default __exports__